import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import React, { useState } from "react";
import { Row, Col, Card } from "react-bootstrap";
import "../styles/FinanceReport.css";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer, BarChart, Bar
} from "recharts";
import { useEffect, useRef } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import axios from "axios";
function FinanceReport() {
    const getPastDate = (days) => {
      const d = new Date();
      d.setDate(d.getDate() - days);
      return d.toISOString().split('T')[0];
    };
  
    const [activeTimeRange, setActiveTimeRange] = useState("1 wk");
    const [startDate, setStartDate] = useState(getPastDate(30));
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const reportRef = useRef(null);

    const handleDownloadPDF = async () => {
      const element = reportRef.current;
      if (!element) return;
      try {
        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save("Finance_Report.pdf");
      } catch (error) {
        console.error("Failed to generate PDF", error);
      }
    };

    const [reportData, setReportData] = useState({
      activeCustomers: 0,
      paymentsReceived: 0,
      overduePayments: 0,
      chartData: []
    });

    const handleTimeRangeClick = (range) => {
      setActiveTimeRange(range);
      const end = new Date().toISOString().split('T')[0];
      let start = "";
      if (range === "1 wk") start = getPastDate(7);
      else if (range === "1 mo") start = getPastDate(30);
      else if (range === "3 mo") start = getPastDate(90);
      else if (range === "1 yr") start = getPastDate(365);
      setStartDate(start);
      setEndDate(end);
    };
  
    const handleManualDateChange = (isStart, val) => {
      setActiveTimeRange("");
      if (isStart) setStartDate(val);
      else setEndDate(val);
    };

    const [status, setStatus] = useState("All");
    const [customer, setCustomer] = useState("All");
    const [subscriptionPlan, setSubscriptionPlan] = useState("All");
    const [customersList, setCustomersList] = useState([]);
    const [subscriptionPlansList, setSubscriptionPlansList] = useState([]);

    useEffect(() => {
      const fetchReport = async () => {
        try {
          const token = localStorage.getItem("token");
          let url = `${process.env.REACT_APP_BASE_API_URL}/api/finance-report?`;
          if (startDate && endDate) {
            url += `startDate=${startDate}&endDate=${endDate}`;
          } else {
            url += `timeRange=${activeTimeRange}`;
          }
          if (customer !== "All") url += `&customerId=${customer}`;
          if (status !== "All") url += `&billingStatus=${status}`;
          if (subscriptionPlan !== "All") url += `&subscriptionPlan=${subscriptionPlan}`;
          
          const res = await axios.get(url, {
            headers: { Authorization: `Bearer ${token}` }
          });
          if (res.data.success) {
            setReportData(res.data.data);
            if (res.data.data.customers) setCustomersList(res.data.data.customers);
            if (res.data.data.subscriptionPlans) setSubscriptionPlansList(res.data.data.subscriptionPlans);
          }
        } catch (err) {
          console.error(err);
        }
      };
      fetchReport();
    }, [startDate, endDate, activeTimeRange, customer, status, subscriptionPlan]);

    const statsData = [
        {
            num: reportData.activeCustomers,
            label: "Active Customers",
            icon: "/images/Leads assigned.svg",
            iconBg: "bg-primary-subtle",
        },
        {
            num: reportData.paymentsReceived,
            label: "Payment Received",
            icon: "/images/win percenatge.svg",
            iconBg: "bg-success-subtle",
        },
        {
            num: reportData.overduePayments,
            label: "Overdue Payments",
            icon: "/images/Cross.svg",
            iconBg: "bg-danger-subtle",
        },
    ];

    const chartData = reportData.chartData.length > 0 ? reportData.chartData : [
        { month: "Jan", value: 0 }, { month: "Feb", value: 0 }, { month: "Mar", value: 0 },
        { month: "Apr", value: 0 }, { month: "May", value: 0 }, { month: "Jun", value: 0 },
        { month: "Jul", value: null }, { month: "Aug", value: null }, { month: "Sep", value: null },
        { month: "Oct", value: null }, { month: "Nov", value: null }, { month: "Dec", value: null }
    ];

    const selectedCustomerData = customersList.find(c => c._id === customer);
    return (
        <>
 <nav
       aria-label="breadcrumb"
       style={{
         "--bs-breadcrumb-divider": "''",
       }}
     >
       <ol
         className="breadcrumb d-flex align-items-center py-2 mb-0"
         style={{ fontSize: "14px" }}
       >
         <li className="breadcrumb-item d-flex align-items-center">
           <Link to="/" className="text-decoration-none text-secondary">
             Home
           </Link>
           <ChevronRight size={16} className="mx-1 text-secondary" />
         </li>
     
         <li
           className="breadcrumb-item fw-semibold"
           style={{ color: "#2F7A87" }}
         >
Report
         </li>
       </ol>
     </nav>

            <div className="ms-4 mt-3">
                {/* Header */}
                <div className="d-flex  mb-4">
                    <i className="bi bi-arrow-left me-3"></i>

                    <div>
                        <h4>Report</h4>
                        <p className="text-muted mb-0">
                            View assigned queries, track leads, and manage sales activities in one place.
                        </p>
                    </div>
                    <div className="ms-auto p-3">
                        <button className="download-btn" onClick={handleDownloadPDF}>
                            <i className="bi bi-download me-2"></i>
                            Download
                        </button>
                    </div>
                </div>

                <div ref={reportRef} style={{ background: "#fff", padding: "15px", borderRadius: "8px" }}>

       <div className="filter-box shadow-sm p-3">
  <div className="filter-row d-flex align-items-end gap-3 flex-nowrap">

    {/* Time Range */}
    <div className="d-flex align-items-center">
      <span className="me-2 fw-medium">Time Range:</span>

      <div className="d-flex gap-2">
        {["1 mo", "3 mo", "1 yr"].map((range) => (
          <button
            key={range}
            className={`btn btn-sm time-btn time-buttont-content ${
              activeTimeRange === range ? "active" : ""
            }`}
            onClick={() => handleTimeRangeClick(range)}
          >
            {range}
          </button>
        ))}
      </div>
    </div>

    <div className="gap-2 d-flex">
      <div className="filter-item">
        <label className="form-label small mb-1">Start</label>
        <input
          type="date"
          className="form-control form-control-sm rounded-pill time-buttont-content"
          value={startDate}
          onChange={(e) => handleManualDateChange(true, e.target.value)}
        />
      </div>
      <div className="filter-item">
        <label className="form-label small mb-1">End</label>
        <input
          type="date"
          className="form-control form-control-sm rounded-pill time-buttont-content"
          value={endDate}
          onChange={(e) => handleManualDateChange(false, e.target.value)}
        />
      </div>
    </div>

    {/* Customer */}
    <div className="filter-item">
      <label className="form-label small mb-1">Customer</label>
      <select
        className="form-select form-select-sm rounded-pill time-buttont-content"
        value={customer}
        onChange={(e) => setCustomer(e.target.value)}
      >
        <option value="All">All</option>
        {customersList.map((c) => (
          <option key={c._id} value={c._id}>{c.fullName}</option>
        ))}
      </select>
    </div>

    {customer === "All" && (
      <>
        <div className="filter-item">
          <label className="form-label small mb-1">Billing Status</label>
          <select
            className="form-select form-select-sm rounded-pill time-buttont-content"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="All">All</option>
            <option value="Paid">Paid</option>
            <option value="Pending">Pending</option>
            <option value="Overdue">Overdue</option>
          </select>
        </div>

        <div className="filter-item">
          <label className="form-label small mb-1">Subscription Plan</label>
          <select 
            className="form-select form-select-sm rounded-pill time-buttont-content"
            value={subscriptionPlan}
            onChange={(e) => setSubscriptionPlan(e.target.value)}
          >
            <option value="All">All</option>
            {subscriptionPlansList.map((p) => (
              <option key={p.id} value={p.plan_name}>{p.plan_name}</option>
            ))}
          </select>
        </div>
      </>
    )}

  </div>
</div>
{customer !== "All" && selectedCustomerData && (
  <Row className="mt-4 mb-3">
    <Col md={6}>
      <Card className="shadow-sm p-3 customer-card">
        <div className="d-flex align-items-center gap-3">

          {/* Icon */}
          <div className="customer-icon">
            <i className="bi bi-person-fill"></i>
          </div>

          {/* Info */}
          <div className="d-flex gap-5">
            <div>
              <div className="text-muted small">Customer Name</div>
              <div className="fw-semibold">
                {selectedCustomerData.fullName || "N/A"}
              </div>
            </div>

            <div>
              <div className="text-muted small">Company</div>
              <div className="fw-semibold">
                N/A
              </div>
            </div>

            <div>
              <div className="text-muted small">Plan</div>
              <div className="fw-semibold">
                {selectedCustomerData.plan_name || "Free"}
              </div>
            </div>
          </div>

        </div>
      </Card>
    </Col>
  </Row>
)}
              {/* Stats Cards */}
{customer === "All" && (
  <Row className="mt-1 g-3 mb-3">
    {statsData.map((item, idx) => (
      <Col key={idx} md={3}>
        <Card className="shadow-sm stat-card">
          <div className="d-flex align-items-center gap-3 px-3">

            {/* Icon */}
            <div className={`icon-circless ${item.iconBg}`}>
              <img src={item.icon} alt="" />
            </div>

            {/* Content */}
            <div>
              <div className="fw-bold fs-5">{item.num}</div>
              <div className="text-muted small">{item.label}</div>
            </div>

          </div>
        </Card>
      </Col>
    ))}
  </Row>
)}
                <Card
                    className="border rounded-3 shadow-sm p-4 col-6"
                    style={{
                        border: "1px solid rgba(209,213,219,1)",
                        background: "#fff"
                    }}
                >
                    <h5 className="mb-4">Revenue trend</h5>

                    <ResponsiveContainer width="100%" height={320}>
                        <LineChart data={chartData}>

                            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />

                            <XAxis
                                dataKey="month"
                                tick={{ fontSize: 13 }}
                            />

                            <YAxis
                                domain={[0, 100]}
                                tick={{ fontSize: 13 }}
                            />

                            <Tooltip />

                            <Line
                                type="monotone"
                                dataKey="value"
                                stroke="#22c55e"
                                strokeWidth={3}
                                dot={{ r: 4 }}
                                connectNulls={false}
                            />

                        </LineChart>
                    </ResponsiveContainer>
                </Card>
                </div>
            </div>
        </>
    );
}

export default FinanceReport;